import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import {
  GET_CUSTOMER_BY_EMAIL,
  IS_MEMBER_OF_GROUP,
  IS_EMAIL,
  EXTERNAL,
  GET_CONTACTS_FOR_ORGANISATION,
  GET_VALIDATE_COUNTRY_CHANGE,
  POST_ENABLE_DISABLE_MAIN_CONTACT,
  DELETE_CONTACT,
  ADD_NEW_PARTNER_CONTACT,
  PARTNER_EMAIL_CONFIG,
  UPDATE_PARTNER_EMAIL_CONFIG,
  TAAS_TAX_ID_VALIDATION,
  TAAS_ADDRESS_VALIDATION,
} from './types';
import {
  getCustomerByEmail,
  isMemberOfGroup,
  isEmail,
  external,
  getContactsForOrganisation,
  getValidateCountryChange,
  deleteContact,
  postEnableDisableMainContact,
  postAddNewPartnerContact,
  getPartnerEmailTemplateConfig,
  updatePartnerEmailTemplateConfig,
  validateTaxIdForOrganisationDetails,
  validateAddressForContactDetails,
} from '../../api';
import { MACCurrentContactData, PartnerEmailTemplateConfig } from '../../models';

export const fetchGetCustomerByEmail = (email: string, includeDeactivated: boolean = false) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const getCustomerByEmailData = getCustomerByEmail(email, includeDeactivated, state);
  dispatch(thunkProgress(GET_CUSTOMER_BY_EMAIL, getCustomerByEmailData, { email }));
};

export const fetchIsMemberOfGroup = (groupName: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const isMemberOfGroupData = isMemberOfGroup(groupName, state);
  dispatch(thunkProgress(IS_MEMBER_OF_GROUP, isMemberOfGroupData));
};

export const fetchIsEmail = () => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  const isEmailData = isEmail(state);
  dispatch(thunkProgress(IS_EMAIL, isEmailData));
};

export const fetchExternal = (contactDetails: MACCurrentContactData) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const externalData = external(state, contactDetails);
  dispatch(thunkProgress(EXTERNAL, externalData));
};

export const fetchContactsForOrganisation = (partnerId: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const contactsForOrg = getContactsForOrganisation(partnerId, state);
  dispatch(thunkProgress(GET_CONTACTS_FOR_ORGANISATION, contactsForOrg, { partnerId }));
};

export const fetchValidateCountryChange = (country: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const contactsForOrg = getValidateCountryChange(country, state);
  dispatch(thunkProgress(GET_VALIDATE_COUNTRY_CHANGE, contactsForOrg, { country }));
};

export const fetchAddNewPartnerContact = (contactDetails) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();
  const newPartnerDetailsResponse = postAddNewPartnerContact(contactDetails, state);
  dispatch(thunkProgress(ADD_NEW_PARTNER_CONTACT, newPartnerDetailsResponse));
};

export const fetchEnableDisableMainContact = (contactId: string, isEnable: boolean) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const mainContactEnable = postEnableDisableMainContact(contactId, isEnable, state);
  dispatch(thunkProgress(POST_ENABLE_DISABLE_MAIN_CONTACT, mainContactEnable));
};

export const fetchDeleteContact = (contactId: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const deleteContactResponse = deleteContact(contactId, state);
  dispatch(thunkProgress(DELETE_CONTACT, deleteContactResponse));
};

export const fetchPartnerEmailTemplateConfig = (partnerId: string) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const contactsForOrg = getPartnerEmailTemplateConfig(partnerId, state);
  dispatch(thunkProgress(PARTNER_EMAIL_CONFIG, contactsForOrg, { partnerId }));
};

export const updatePartnerEmailTemplateConfigAction = (
  partnerId: string,
  templateConfig: PartnerEmailTemplateConfig,
) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();

  const contactsForOrg = updatePartnerEmailTemplateConfig(partnerId, templateConfig, state);
  dispatch(thunkProgress(UPDATE_PARTNER_EMAIL_CONFIG, contactsForOrg, { partnerId }));
};

export const validateTaxIdForOrganisationDetailsAction = (orgDetails: any) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const contactsForOrg = validateTaxIdForOrganisationDetails(orgDetails, state);
  dispatch(thunkProgress(TAAS_TAX_ID_VALIDATION, contactsForOrg, { taxId: orgDetails.taxId }));
};

export const validateAddressForContactDetailsAction = (contactDetails: any) => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  const state = getState();

  const validationResult = validateAddressForContactDetails(contactDetails, state);
  dispatch(
    thunkProgress(TAAS_ADDRESS_VALIDATION, validationResult, {
      addressKey:
        contactDetails?.organisationDetails?.address1 +
        contactDetails?.organisationDetails?.address2,
    }),
  );
};
